var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'core', 'component/document-viewer', 'component/report/editing', 'component/report/ledger-control', 'app-common/component/loader', 'common/component/money-formatter', 'common/component/date-formatter', 'app-common/component/confirm-dialog', 'app-common/component/binary-toggle', 'app-common/component/api-call', 'app-common/component/notification', 'component/tax-calculator', 'template/report/data/ledger-transactions.htm', 'template/report/data/transactions.htm', 'template/report/report-tools.htm', 'common/lib/jquery.datatables', 'common/lib/date'], function($, _, _s, core, DocumentViewer, editing, ledgerControl, loader, moneyFormatter, dateFormatter, confirmDialog, BinaryToggleView, apiCall, NotificationSupport, taxCalculator, ledgersReportTemplate, transactionsReportTemplate, reportToolsTemplate) {
  var SimpleNotification, addRow, addTransactionData, addTransactionToTable, addTransactionsToTable, batchEditing, changeTransactionsByDocument, clear, contextWidgetType, countRows, currentLedger, datatable, defaultNoResultsMessage, disableBatchEdit, disableEdit, enableBatchEdit, enableEdit, escape, getDocumentIdByRow, getIdByTransactionRow, getTransactionAmountFromDataEntries, getTransactionData, getTransactionRow, hideEdit, initReportData, initReportTools, initTable, isClosedReport, isEdit, loadCallback, notification, removeRow, removeTransactionData, rowClickCallback, save, saveBatchEdit, saveEdit, showLedgerEdit, showVendorEdit, transactionalData, updateTransactionData;
  transactionalData = [];
  datatable = null;
  currentLedger = null;
  contextWidgetType = null;
  isClosedReport = null;
  loadCallback = null;
  rowClickCallback = null;
  batchEditing = false;
  defaultNoResultsMessage = 'You have no transactions for the selected period.';
  SimpleNotification = (function(_super) {

    __extends(SimpleNotification, _super);

    function SimpleNotification() {
      SimpleNotification.__super__.constructor.apply(this, arguments);
    }

    SimpleNotification.prototype.notificationSelector = function() {
      return '.widget .notification-area';
    };

    return SimpleNotification;

  })(NotificationSupport);
  notification = new SimpleNotification;
  escape = function(txt) {
    return txt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  };
  /* TABLE MANAGEMENT
  */

  initTable = function(element, noResultsMessage) {
    var columns, drawCallback, rowCallback, table;
    table = $(element).find('table');
    columns = [
      {
        aTargets: [0],
        sTitle: '<div class="batch-edit"><input type="checkbox" id="batch-edit-select-all" /></div>',
        mData: null,
        sClass: 'batch-edit-column excludeFromRowClick',
        sWidth: '4%',
        mRender: function() {
          return '<input type="checkbox" class="batch-edit-checkbox" />';
        }
      }, {
        aTargets: [1],
        mData: null,
        sClass: 'date_column',
        sWidth: '8.2%',
        mRender: function(data, type, full) {
          var date;
          date = Date.parse(full.documentDate);
          return ("<span class='month-day'>" + (date.toString('MMM')) + " " + (date.toString('dd')) + "</span><br />") + ("<span class='year'>" + (date.getFullYear()) + "</span>");
        }
      }, {
        aTargets: [2],
        sTitle: '\
                <div class="batch-edit"><input type="text" id="batch-edit-company" class="batch-edit-control" placeholder="[No Change]"/></div>\
                Company',
        mData: 'vendor',
        sClass: 'vendor',
        sWidth: '31.9%',
        mRender: function(data, type, full) {
          return _s.escapeHTML(data);
        }
      }, {
        aTargets: [3],
        sTitle: '\
                <div class="batch-edit"><span id="batch-edit-ledger"></span></div>\
                Account',
        mData: null,
        sClass: 'ledger',
        sWidth: '35.7%',
        mRender: function(data, type, full) {
          var simpleLedgers;
          simpleLedgers = full.documentType === 'RECEIPT';
          return "<span class='label editable'>" + (ledgerControl.renderLedgers(full, simpleLedgers)) + "</span>";
        }
      }, {
        aTargets: [4],
        mData: null,
        sClass: 'actions_column',
        sWidth: '12%',
        mRender: function(data, type, full) {
          var flagged, getNoteCounts, iconHtml, unflagged, _ref;
          getNoteCounts = function(notes) {
            var note, notesArray, ret, _i, _len;
            ret = {
              flagged: 0,
              unflagged: 0
            };
            notesArray = notes || [];
            for (_i = 0, _len = notesArray.length; _i < _len; _i++) {
              note = notesArray[_i];
              if (note.flagged) {
                ret.flagged += 1;
              } else {
                ret.unflagged += 1;
              }
            }
            return ret;
          };
          _ref = getNoteCounts(full.internalNotes), flagged = _ref.flagged, unflagged = _ref.unflagged;
          iconHtml = '';
          if (full.fileId != null) {
            iconHtml += '<div class="receipt-action action-icon"><span class="ss-gizmo ss-file"></span></div>';
          }
          if (unflagged > 0) {
            iconHtml += '<div class="action-icon"><span class="ss-gizmo ss-users"></span></div>';
          }
          if (flagged > 0) {
            iconHtml += '<div class="action-icon"><span class="ss-gizmo ss-flag"></span></div>';
          }
          return iconHtml;
        }
      }, {
        aTargets: [5],
        sTitle: '\
                <div class="batch-edit"><button id="batch-edit-submit" class="btn">Submit</button></div>\
                Amount',
        mData: null,
        sClass: 'amount excludeFromRowClick ie8-last-child',
        sType: 'money',
        sWidth: '12.2%',
        mRender: function(data, type, full) {
          var amount, formattedAmount, id, path;
          amount = full.amount != null ? full.amount : getTransactionAmountFromDataEntries(full);
          formattedAmount = moneyFormatter.formatNumber(amount);
          if (core.isCurrentClientBookkeeper() && !isClosedReport()) {
            id = full.id;
            path = core.getRouter().buildUrl('document-entry', [id, 'single']);
            return "<a href=" + path + "><span class='show-document-entry clickable' data-id='" + id + "'>" + formattedAmount + "</span></a>";
          } else {
            return formattedAmount;
          }
        }
      }
    ];
    if (core.isCurrentClientBookkeeper()) {
      if (contextWidgetType === 'unmatched-receipts' || contextWidgetType === 'unmatched-receipts-search') {
        columns.push({
          aTargets: [6],
          mData: null,
          sTitle: '<input type="checkbox" class="select-all" />',
          sClass: 'delete_column ie8-last-child right',
          sWidth: '6.25%',
          mRender: function() {
            return '<input type="checkbox" class="delete-action" />';
          }
        });
        initReportTools();
      }
    }
    $(element).find('tfoot td').attr('colspan', columns.length);
    rowCallback = function(row, data) {
      if ($(row).hasClass('transaction_row')) {
        return row;
      }
      $(row).attr('id', "transaction_id_" + data.id).addClass('transaction_row').addClass('transactions-list__row').addClass("document_id_" + data.id).addClass('details-enabled');
      $('td:not(.excludeFromRowClick)', row).on('click', function(e) {
        return rowClickCallback(e, data);
      });
      $(row).on('click', '.show-document-entry', function(e) {
        var ctrlCmd, id;
        ctrlCmd = core.isMac() ? e.metaKey : e.ctrlKey;
        if (!ctrlCmd) {
          id = $(this).data('id');
          core.getRouter().loadPage('document-entry', [id, 'single']);
          return false;
        }
      });
      return row;
    };
    drawCallback = function() {
      var isEmpty;
      if (contextWidgetType !== 'confirmation') {
        return;
      }
      isEmpty = $('.dataTable tbody tr:first .dataTables_empty').length > 0;
      if (isEmpty) {
        return $('#reports-sweep-button').hide();
      } else {
        return $('#reports-sweep-button').show();
      }
    };
    $.fn.dataTableExt.sErrMode = 'throw';
    datatable = table.dataTable({
      aoColumnDefs: columns,
      fnRowCallback: rowCallback,
      fnDrawCallback: drawCallback,
      oLanguage: {
        sEmptyTable: noResultsMessage
      },
      bInfo: false,
      bLengthChange: false,
      bFilter: false,
      bPaginate: false,
      bAutoWidth: false,
      bSort: false
    });
    $(document).on('click', '.actions_column .receipt-action', function() {
      var data, id, row;
      row = $(this).closest('.transaction_row');
      id = getIdByTransactionRow(row);
      data = getTransactionData(id);
      return new DocumentViewer({
        document: data.id
      });
    });
    addTransactionsToTable(transactionalData);
    if (_.isFunction(loadCallback)) {
      return loadCallback();
    }
  };
  addTransactionsToTable = function(transactions) {
    var transaction, _i, _len;
    for (_i = 0, _len = transactions.length; _i < _len; _i++) {
      transaction = transactions[_i];
      datatable.fnAddData(transaction, false);
      addTransactionData(transaction);
    }
    return datatable.fnDraw();
  };
  addTransactionToTable = function(transaction) {
    return datatable.fnAddData(transaction);
  };
  addRow = function(data) {
    addTransactionData(data);
    return addTransactionToTable(data);
  };
  removeRow = function(transactionId, noAnimation) {
    var deleteFunc, row;
    row = getTransactionRow(transactionId);
    deleteFunc = function() {
      datatable.fnDeleteRow(row[0]);
      return removeTransactionData(transactionId);
    };
    if (noAnimation) {
      return deleteFunc();
    } else {
      return row.fadeOut('slow', deleteFunc);
    }
  };
  clear = function() {
    return datatable.fnClearTable();
  };
  countRows = function() {
    return $('.transaction_row:visible').length;
  };
  /* BOOKKEEPER TOOLS
  */

  initReportTools = function() {
    $('.report-tools').show();
    $(document).on('change', '.delete_column .delete-action', function() {
      var disabled;
      disabled = !$('.delete_column .delete-action').is(':checked');
      return $('.remove-tool').prop('disabled', disabled);
    });
    $(document).on('change', '.delete_column .select-all', function(e) {
      var checked;
      checked = $(e.currentTarget).is(':checked');
      $('.remove-tool').prop('disabled', !checked);
      return $('.delete_column .delete-action').prop('checked', checked);
    });
    return $('.remove-tool').click(function() {
      confirmDialog.init('Are you sure?', {
        ok: 'OK',
        cancel: 'Cancel'
      });
      return $('.confirm-ok').on('click', function() {
        var entries, promise;
        entries = $('.delete_column .delete-action:checked').map(function() {
          var row, tData, transactionId;
          row = $(this).closest('.transaction_row');
          transactionId = getIdByTransactionRow(row);
          tData = getTransactionData(transactionId);
          return tData.id;
        });
        loader.init();
        promise = apiCall('document', 'list?ids=' + entries.get().join(","), 'DELETE');
        promise.always(function() {
          loader.hide();
          return confirmDialog.hide();
        });
        return promise.done(function() {
          return core.getRouter().refreshPage();
        });
      });
    });
  };
  /* BATCH EDIT MODE
  */

  enableBatchEdit = function() {
    $('.transaction_row').addClass('batch-edit-mode');
    $('.batch-edit-checkbox:checked').closest('.transaction_row').addClass('batch-edit-highlight');
    $('.batch-edit-column').show();
    return batchEditing = true;
  };
  disableBatchEdit = function() {
    $('.transaction_row').removeClass('batch-edit-mode');
    $('.transaction_row').removeClass('batch-edit-highlight');
    $('.batch-edit-column').hide();
    return batchEditing = false;
  };
  /* EDIT MODE
  */

  enableEdit = function(settings) {
    var startEdit;
    if (settings == null) {
      settings = {};
    }
    startEdit = function() {
      var selector, transactions;
      selector = settings.partially ? '.transaction_row:not(.edit-mode)' : '.transaction_row';
      transactions = $(selector);
      if (transactions.length === 0) {
        loader.hide();
        return;
      }
      editing.init();
      transactions.each(function(i, row) {
        var dataEntry, transaction, _i, _len, _ref;
        transaction = getTransactionData(getIdByTransactionRow(row));
        $(row).addClass('edit-mode');
        _ref = transaction.dataEntries;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          dataEntry = _ref[_i];
          showLedgerEdit(dataEntry, row);
        }
        return showVendorEdit(transaction, $(row).children('.vendor'));
      });
      loader.hide();
      return editing.on();
    };
    if (contextWidgetType === 'confirmation') {
      return startEdit();
    } else {
      loader.init({
        spinnerContainer: '.page-wrapper'
      });
      return setTimeout(startEdit, 100);
    }
  };
  showLedgerEdit = function(dataEntry, row) {
    var sync;
    sync = function() {
      var data, ledgerData, ledgerId, self, transactionId;
      self = $(this);
      data = ledgerControl.getData(self.parent());
      ledgerData = editing.getLedgerValue(self.parent());
      transactionId = data['transaction-id'];
      ledgerId = data['ledger-id'];
      return ledgerControl.getControl(ledgerId, transactionId).each(function(i, element) {
        var input;
        input = $(element).children("input[type='text'], textarea, select");
        if (input[0] !== self[0]) {
          editing.setLedgerValue(ledgerData, element);
          input.trigger('refreshWidth');
          input.off('blur.adjacent');
          return self.off('blur.adjacent').on('blur.adjacent', function() {
            return input.trigger('blur');
          });
        }
      });
    };
    return editing.showLedgerEdit(dataEntry, ledgerControl.getControl(dataEntry.ledgerAccountId, dataEntry.id, row), sync);
  };
  showVendorEdit = function(transaction, row) {
    var sync;
    sync = function() {
      var self;
      self = $(this);
      row = self.closest('tr');
      return changeTransactionsByDocument(row, 'td.vendor textarea', function(foundInput) {
        if (foundInput[0] !== self[0]) {
          return foundInput.val(self.val());
        }
      });
    };
    return editing.showVendorEdit(transaction, row, sync, true);
  };
  disableEdit = function(callback) {
    $('.transaction_row').each(function(i, row) {
      var tData;
      tData = getTransactionData(getIdByTransactionRow(row));
      $('.ledger-item.edit-on').each(function(i, el) {
        return editing.hideLedgerEdit(editing.getLedgerValue(el).name, el);
      });
      return editing.hideVendorEdit(tData.vendor, $(row).children('.vendor'));
    });
    $('.edit-mode').removeClass('edit-mode');
    editing.off();
    if (_.isFunction(callback)) {
      return callback();
    }
  };
  saveBatchEdit = function(company, oldLedgerId, newLedgerId, callback) {
    var checkedBoxes, toSave;
    toSave = [];
    checkedBoxes = $('.batch-edit-checkbox:checked');
    if (checkedBoxes.length === 0) {
      notification.showNotification({
        type: 'error',
        text: 'Please select at least one transaction'
      }, true, true, true);
      return;
    }
    checkedBoxes.closest('.transaction_row').each(function(i, row) {
      var ledgerTransId, tData;
      tData = getTransactionData(getIdByTransactionRow(row));
      if (company != null) {
        toSave.push({
          documentId: tData.id,
          vendor: this.sanitized(company)
        });
      }
      if (newLedgerId != null) {
        ledgerTransId = $(row).find(".ledger-item[data-ledger-id='" + oldLedgerId + "']").attr('data-transaction-id');
        return toSave.push({
          documentId: tData.id,
          ledgerId: parseInt(newLedgerId),
          id: parseInt(ledgerTransId)
        });
      }
    });
    confirmDialog.init('Are you sure you wish to edit these ' + checkedBoxes.length + ' transactions?', {
      ok: 'Yes',
      cancel: 'Cancel'
    }, true);
    return $('.confirm-ok').on('click', function() {
      return save(toSave, confirmDialog, function(saveData) {
        return callback(saveData);
      });
    });
  };
  saveEdit = function(callback) {
    var toSave;
    toSave = [];
    $('.transaction_row').each(function(i, row) {
      var isConfirmed, newVendor, oldVendor, tData, transactionId;
      if ($(row).children('td').hasClass('dataTables_empty')) {
        return;
      }
      try {
        transactionId = getIdByTransactionRow(row);
        tData = getTransactionData(transactionId);
        oldVendor = tData.vendor.trim();
        newVendor = editing.getVendorValue($(row).children('.vendor'));
        if (newVendor !== void 0 && oldVendor !== newVendor) {
          toSave.push({
            documentId: tData.id,
            vendor: newVendor
          });
          updateTransactionData(transactionId, {
            vendor: escape(newVendor)
          }, false);
        }
        $('.ledger-item.edit-on', row).each(function(i, el) {
          var data, ledgerData, ledgerItem, ledgerTransactionId, newLedger, oldLedgerId;
          data = ledgerControl.getData(el);
          ledgerTransactionId = data['transaction-id'];
          oldLedgerId = data['ledger-id'];
          newLedger = editing.getLedgerValue(el);
          if (newLedger.id !== oldLedgerId) {
            ledgerData = {
              id: ledgerTransactionId,
              ledgerId: newLedger.id,
              documentId: tData.id
            };
            toSave.push(ledgerData);
            ledgerItem = _.findWhere(tData.dataEntries, {
              id: ledgerTransactionId.toString()
            });
            ledgerItem.ledgerAccountId = newLedger.id;
            ledgerItem.ledgerAccountName = newLedger.name;
            return ledgerControl.update({
              'ledger-id': newLedger.id
            }, el);
          }
        });
        isConfirmed = $(row).hasClass('confirmed');
        if (isConfirmed) {
          return toSave.push({
            documentId: tData.id,
            confirmed: true
          });
        }
      } catch (e) {

      }
    });
    if (toSave.length > 0) {
      return save(toSave, null, callback);
    } else {
      if (_.isFunction(callback)) {
        return callback(toSave);
      }
    }
  };
  save = function(toSave, confirmDialog, callback) {
    var promise;
    loader.init();
    promise = apiCall('document', "list", 'PUT', {
      entries: toSave
    });
    promise.done(function() {
      core.trackEvent("Transaction Updated", {
        updated_field: "both",
        batch_mode: true,
        count: toSave.length
      });
      if (_.isFunction(callback)) {
        return callback(toSave);
      }
    });
    promise.fail(function() {
      return notification.showNotification({
        type: 'error',
        text: 'Sorry, these transactions could not be saved. Please check that the Company field has been filled in correctly'
      });
    });
    return promise.always(function() {
      loader.hide();
      return confirmDialog != null ? confirmDialog.hide() : void 0;
    });
  };
  hideEdit = function() {
    return editing.off();
  };
  isEdit = function() {
    return editing.isActive();
  };
  /* DOM HELPERS
  */

  getTransactionRow = function(transactionId) {
    return $("#transaction_id_" + transactionId);
  };
  getIdByTransactionRow = function(row) {
    var rowId;
    rowId = $(row).attr('id').replace('transaction_id_', '');
    if (_.isNumber(rowId)) {
      return parseInt(rowId);
    } else {
      return rowId;
    }
  };
  getDocumentIdByRow = function(row) {
    return parseInt(/document_id_([0-9]+)/i.exec($(row).attr('class'))[1]);
  };
  changeTransactionsByDocument = function(row, elementSelector, changeAction) {
    var documentId, selector;
    documentId = getDocumentIdByRow(row);
    if (documentId == null) {
      return;
    }
    selector = ".transaction_row.document_id_" + documentId + ":visible";
    if (elementSelector) {
      selector += ' ' + elementSelector;
    }
    return $(selector).each(function(i, el) {
      return changeAction($(el));
    });
  };
  /* DATA HELPERS
  */

  getTransactionData = function(id) {
    return _.findWhere(transactionalData, {
      id: id
    });
  };
  updateTransactionData = function(id, data, updateTable) {
    var key, transaction, transactionRow, val;
    if (updateTable == null) {
      updateTable = true;
    }
    if ((transaction = getTransactionData(id)) && (transactionRow = getTransactionRow(id)[0])) {
      for (key in data) {
        val = data[key];
        transaction[key] = val;
      }
      if (updateTable) {
        return datatable.fnUpdate(transaction, transactionRow);
      }
    }
  };
  addTransactionData = function(data) {
    return transactionalData.push(data);
  };
  removeTransactionData = function(id) {
    var i, transaction, _i, _len, _results;
    _results = [];
    for (i = _i = 0, _len = transactionalData.length; _i < _len; i = ++_i) {
      transaction = transactionalData[i];
      if (transaction.transactionId === id) {
        transactionalData.splice(i, 1);
        break;
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };
  getTransactionAmountFromDataEntries = function(transaction) {
    var dataEntriesToSum;
    dataEntriesToSum = (function() {
      switch (transaction.documentType) {
        case 'TRANSACTIONAL':
          return _.filter(transaction.dataEntries, function(entry) {
            return entry.amount > 0;
          });
        case 'RECEIPT':
          return transaction.dataEntries;
      }
    })();
    return _.reduce(dataEntriesToSum, (function(memo, de) {
      return memo + de.amount;
    }), 0);
  };
  initReportData = function(transactions, widgetType, ledger) {
    transactionalData = transactions;
    contextWidgetType = widgetType;
    currentLedger = ledger;
    return editing.init();
  };
  return {
    initLedgersReportTemplate: function(element, transactions, widgetType, ledger) {
      $(element).html(reportToolsTemplate + ledgersReportTemplate);
      initReportData(transactions, widgetType, ledger);
      return initTable(element, defaultNoResultsMessage);
    },
    initTransactionsReportTemplate: function(element, transactions, widgetType, closedReportCheck) {
      var noResultsMessage;
      $(element).html(reportToolsTemplate + transactionsReportTemplate);
      isClosedReport = closedReportCheck;
      initReportData(transactions, widgetType);
      noResultsMessage = (function() {
        switch (widgetType) {
          case 'confirmation':
            return 'You have no transactions that need to be confirmed.';
          case 'search':
            return 'You have no transactions that match your request.';
          case 'unmatched-receipts':
            return 'You have no unmatched receipts';
          case 'unmatched-receipts-search':
            return 'You have no unmatched receipts that match your request.';
          default:
            return defaultNoResultsMessage;
        }
      })();
      return initTable(element, noResultsMessage);
    },
    setLoadCallback: function(callback) {
      return loadCallback = callback;
    },
    setRowClickCallback: function(callback) {
      return rowClickCallback = callback;
    },
    updateTransactionData: updateTransactionData.bind(this),
    addRow: addRow,
    removeRow: removeRow,
    setTransactions: function(transactions) {
      clear();
      return addTransactionsToTable(transactions);
    },
    clear: clear.bind(this),
    getIdByTransactionRow: getIdByTransactionRow,
    getTransactionRow: getTransactionRow,
    getTransactionData: getTransactionData,
    countRows: countRows,
    hide: function() {
      loadCallback = null;
      editing.hide();
      $(document).off('click', '.actions_column .receipt-action');
      $(document).off('change', '.delete_column .delete-action');
      $(document).off('change', '.delete_column .select-all');
      return $('.flexselect_dropdown').remove();
    },
    enableBatchEdit: enableBatchEdit,
    disableBatchEdit: disableBatchEdit,
    isBatchEdit: function() {
      return batchEditing;
    },
    enableEdit: enableEdit,
    disableEdit: disableEdit,
    saveEdit: saveEdit,
    saveBatchEdit: saveBatchEdit,
    hideEdit: hideEdit,
    isEdit: isEdit
  };
});
